import api from '../../interceptorServices';
import base_url from '../../../config';
const path = base_url+'api/event/emregistration';
const countriesUrl = base_url+'api/admin/esCountries';
const registrationAddonSummaryUrl = base_url+'api/admin/registrationAddonSummary';
const registrationSummaryUrl = base_url+'api/admin/registrationSummary';

export const getData = async (params) => {
  const whereParam = params;
  const response = await api.post(path, whereParam);
  return response.data.data;
};

export const addData = async (data) => {
  const response = await api.post(path, data);
  return response.data;
};

export const updateData = async (data) => {
  const response = await api.put(path, data);
  return response.data;
};

export const deleteData = async (data) => {
  const response = await api.delete(path, {
    data: { selfregistration_id: data.selfregistration_id },
  });
  return response.data;
};

export const getcountries = async () => {
    const response = await api.get(countriesUrl);
    return response.data.data;
};

export const getregistrationAddonSummary = async (params) => {
  const whereParam = params;
  const response = await api.post(registrationAddonSummaryUrl, whereParam);
  return response.data.data;
};

export const getregistrationSummary = async (params) => {
  const whereParam = params;
  const response = await api.post(registrationSummaryUrl, whereParam);
  return response.data.data;
};
